<template>
    <div>
        <div class="columns align-items-center">
            <div class="column">
                <slot><h6 class="m-0">{{ translate("Schedule") }}</h6></slot>
            </div>
            <div class="column flex-static">
                <default-button
                    :flavor="unfiltered ? 'normal' : 'link'"
                    :color="unfiltered ? 'primary' : 'regular'"
                    size="sm"
                    @click.prevent="unfiltered = !unfiltered"
                >
                    <span v-if="unfiltered">{{ translate("Hide Unavailable") }}</span>
                    <span v-else>{{ translate("Show Unavailable") }}</span>
                </default-button>
            </div>
        </div>
        <table class="table table-event-quartet-slots">
            <tbody>
                <tr
                    v-for="slot in filteres_slots"
                    :key="slot.id"
                    :class="{ booked: (slot.status === constants('event_quartet_slot_statuses', 'STATUS_BOOKED').id), blocked: (slot.status === constants('event_quartet_slot_statuses', 'STATUS_RESERVED').id), travel: (slot.status === constants('event_quartet_slot_statuses', 'STATUS_TRAVEL').id) }"
                >
                    <td class="col-time">
                        {{ slot.starts_at | nibnut.date("h:mm A") }}
                        <div class="text-small text-gray">{{ slot.starts_at | nibnut.date("YYYY-MM-DD") }}</div>
                    </td>
                    <td>
                        <form-dropdown
                            :id="`status-${slot.id}`"
                            name="status"
                            v-model="slot.status"
                            :options="event_quartet_slot_statuses"
                            enabled-field="assignable"
                            :required="true"
                            :disabled="(slot.status === constants('event_quartet_slot_statuses', 'STATUS_BOOKED').id)"
                            @input="$emit('input', $event, 'status', slot)"
                        />
                    </td>
                    <td class="col-link">
                        <app-icon
                            v-if="(slot.status === constants('event_quartet_slot_statuses', 'STATUS_RESERVED').id)"
                            glyph="lock-keyhole"
                            size="lg"
                        />
                        <app-icon
                            v-else-if="(slot.status === constants('event_quartet_slot_statuses', 'STATUS_TRAVEL').id)"
                            glyph="car"
                            size="lg"
                        />
                        <singing-telegram-info-buttons
                            v-else-if="!!slot.singing_telegram_id"
                            :telegram-id="slot.singing_telegram_id"
                            @click="$emit('click', slot)"
                        />
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script type="text/javascript">
import misc_utilities from "@/nibnut/mixins/MiscUtilities"

import DefaultButton from "@/nibnut/components/Buttons/DefaultButton"
import FormDropdown from "@/nibnut/components/Inputs/FormDropdown"
import AppIcon from "@/nibnut/components/AppIcon"
import SingingTelegramInfoButtons from "@/custom/components/SingingTelegramInfoButtons"

export default {
    name: "EventQuartetSlotsList",
    mixins: [misc_utilities],
    components: {
        DefaultButton,
        FormDropdown,
        AppIcon,
        SingingTelegramInfoButtons
    },
    computed: {
        event_quartet_slot_statuses () {
            const booked_status_id = this.constants("event_quartet_slot_statuses", "STATUS_BOOKED").id
            return Object.values(this.constants("event_quartet_slot_statuses")).map(status => {
                status.assignable = (status.id !== booked_status_id)
                return status
            })
        },
        filteres_slots () {
            if(this.unfiltered) return this.slots
            const reserved_status_id = this.constants("event_quartet_slot_statuses", "STATUS_RESERVED").id
            return this.slots.filter(slot => {
                return (slot.status !== reserved_status_id)
            })
        }
    },
    props: {
        slots: {
            type: Array,
            required: true
        }
    },
    data () {
        return {
            unfiltered: false
        }
    }
}
</script>

<style lang="scss">
@import "@/assets/sass/app";

.table.table-event-quartet-slots {
    tr {
        td {
            vertical-align: middle;
            &.col-time {
                width: 130px;
            }
            &.col-link {
                width: 1px;
            }
        }

        &.booked {
            background-color: $success-color-light;
        }
        &.blocked {
            opacity: 0.7;
        }
        &.travel {
            background-color: $gray-color-light;
        }
    }
}
</style>
